import api from '@/apis/di/accountParallelRuleAPI';
import Crud from '@/stores/crudBaseCache';
import indexedDB from '@/commons/indexedDB';

var crud = new Crud('accountParallelRule', api);
const state = {
  ...crud.state,
  _config: {
    table: 'di_account_parallel_rule',
    field: {
      key: 'account_parallel_rule_id',
    },
  },
};
const getters = {
  ...crud.getters,
};
const actions = {
  ...crud.actions,
  /**
   * Update multiple
   * HTHAI 07.06.2022
   */
  async addAndUpdateMultiple(context, param) {
    let res = await api.addAndUpdateMultiple(param);
    if (res && Array.isArray(res)) {
      const cacheName = `cacheDi_accountParallelRule`;
      const indexDb = new indexedDB();
      const data = await indexDb.get(cacheName);
      const { localVersion } = data;
      await indexDb.delete(cacheName, {
        localVersion: localVersion,
        localData: res,
      });
      context.commit('setItems', res);
    }
    return res;
  },
  /**
   * Overwrite data
   */
  async overwrite(context, param) {
    let res = await api.overwrite(param);

    if (res && Array.isArray(res)) {
      const cacheName = `cacheDi_accountParallelRule`;
      const indexDb = new indexedDB();
      const data = await indexDb.get(cacheName);
      const { localVersion } = data;
      await indexDb.delete(cacheName, {
        localVersion: localVersion,
        localData: res,
      });

      context.commit('setItems', res);
    }

    //HTHIEP 08.07.2022: Update lại state khi cập nhật dữ liệu
    context.commit('setItems', []);

    return res;
  },

  /**
   * Lấy dữ liệu default
   */
  async default(context, param) {
    let res = await api.default(param);

    return res;
  },

  async loadFullCache({ dispatch, commit, getters },
    payload) {
      
    if (!payload) {
      payload = {};
    } else {
      if (!payload.columns) {
        payload.columns = "*";
      }
    }
    const indexDb = new indexedDB();
    const key = 'cacheDi_accountParallelRule';
    const data = await indexDb.get(key);
    const config = getters[`_config`];
    const defaultSort = config.defaultSort ? config.defaultSort : config?.field?.code;
    if (data) {
      const { localVersion, localData } = data;
      // gán lại remoteVersion
      // pqkhanh  28.03.2023
      if (payload.isReload && !payload.remoteVersion) {
        payload.remoteVersion = localVersion
      }
      if (localVersion < payload.remoteVersion || !localData || payload.isReload) {
        const remoteData = await dispatch('getAndSetCache', {defaultSort, key, payload});
        commit('setItems', remoteData);
        return remoteData;
      } else {
        commit('setItems', localData);
        return localData;
      }
    } else {
      const remoteData = await dispatch('getAndSetCache', {defaultSort, key, payload});
      commit('setItems', remoteData);
      return remoteData;
    }
  }
};
const mutations = {
  ...crud.mutations,
  setAccountParallelRules(state, data) {
    state.accountParallelRules = data;
  },
};

export default {
  debug: process.env.NODE_ENV !== 'production',
  namespaced: true,
  state,
  mutations,
  actions,
  getters,
};
